/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A response from creating a payment intent with Stripe.
 * @export
 * @interface StripeCheckoutSessionResponse
 */
export interface StripeCheckoutSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof StripeCheckoutSessionResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof StripeCheckoutSessionResponse
     */
    status: StripeCheckoutSessionResponseStatusEnum;
}


/**
 * @export
 */
export const StripeCheckoutSessionResponseStatusEnum = {
    Open: 'open',
    Complete: 'complete',
    Expired: 'expired'
} as const;
export type StripeCheckoutSessionResponseStatusEnum = typeof StripeCheckoutSessionResponseStatusEnum[keyof typeof StripeCheckoutSessionResponseStatusEnum];


/**
 * Check if a given object implements the StripeCheckoutSessionResponse interface.
 */
export function instanceOfStripeCheckoutSessionResponse(value: object): value is StripeCheckoutSessionResponse {
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function StripeCheckoutSessionResponseFromJSON(json: any): StripeCheckoutSessionResponse {
    return StripeCheckoutSessionResponseFromJSONTyped(json, false);
}

export function StripeCheckoutSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeCheckoutSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientSecret': json['client_secret'],
        'status': json['status'],
    };
}

export function StripeCheckoutSessionResponseToJSON(json: any): StripeCheckoutSessionResponse {
    return StripeCheckoutSessionResponseToJSONTyped(json, false);
}

export function StripeCheckoutSessionResponseToJSONTyped(value?: StripeCheckoutSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_secret': value['clientSecret'],
        'status': value['status'],
    };
}

